import { Optional } from '@dtx-company/flowcode-utils/src'

export enum BrandKitFormFields {
  PrimaryText = 'primaryText',
  LogoImage = 'logoImage',
  PrimaryColor = 'primaryColor',
  SecondaryColor = 'secondaryColor'
}

export interface BrandKitFormInputs {
  [BrandKitFormFields.PrimaryText]: string
  [BrandKitFormFields.LogoImage]?: string
  [BrandKitFormFields.PrimaryColor]?: string
  [BrandKitFormFields.SecondaryColor]?: string
}

export interface BrandKit {
  templatesListFlowcodeImage: Optional<string>
  editorFlowcodeImage: Optional<string>
  highlightedTemplatesFlowcodeImage: Optional<string>
  [BrandKitFormFields.LogoImage]?: Optional<string>
  [BrandKitFormFields.PrimaryText]: Optional<string>
  [BrandKitFormFields.PrimaryColor]: Optional<string>
  [BrandKitFormFields.SecondaryColor]: Optional<string>
}
